import { render } from "./CollectionDescription.vue?vue&type=template&id=304a6d36&scoped=true"
import script from "./CollectionDescription.vue?vue&type=script&lang=js"
export * from "./CollectionDescription.vue?vue&type=script&lang=js"

import "./CollectionDescription.vue?vue&type=style&index=0&id=304a6d36&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304a6d36"]])

export default __exports__